<template>
  <Row>
    <Col span="24">
      <Form :label-width="80">
        <FormItem label="选择平台">
          <Select class="form-item-clazz" v-model="currentPlat">
            <Option v-for="(it, id) in platList" :key="id" :value="it.platCode" :label="it.platName"></Option>
          </Select>
        </FormItem>
      </Form>
    </Col>
    <Col span="24">
      <Card dis-hover>
        <Row :gutter="5">
          <Col span="12">
            <Card dis-hover>
              <p slot="title">{{currentPlat}}平台菜单列表</p>
              <p slot="extra">
                <Button type="primary" size="small" @click="openAddHandle">新增菜单</Button>
              </p>
              <Tree
                :data="treeData"
                check-strictly
                show-checkbox
                ref="tree"
                @on-select-change="selectChangeTree"
              ></Tree>
            </Card>
          </Col>
          <Col span="12">
            <Card v-show="!isAdd" dis-hover>
              <p slot="title">修改-{{currentMenu.name}}</p>
              <Form :label-width="80" :model="currentMenu" :rules="modifyRules" ref="modifyRef">
                <FormItem label="父级菜单">
                  <Input v-model="currentMenu.parentName" disabled/>
                </FormItem>
                <FormItem label="菜单名称" prop="name">
                  <Input v-model="currentMenu.name" :maxlength="50" />
                </FormItem>
                <FormItem label="路径" prop="path">
                  <Input v-model="currentMenu.path" :maxlength="50" />
                </FormItem>
                <FormItem label="状态" prop="status">
                  <i-switch size="large" v-model="currentMenu.booleanStatus">
                    <span slot="open">启用</span>
                    <span slot="close">禁用</span>
                  </i-switch>
                </FormItem>
                <FormItem class="form-btn-group">
                  <!--                  <Button type="primary" @click="openRoleMenu">菜单分配</Button>-->
                  <Button type="error" :loading="submitLoading" @click="removeMenuItem">删除</Button>
                  <Button style="margin-left: 5px;" type="success" :loading="submitLoading" @click="postModifyMenu">
                    确认修改
                  </Button>
                </FormItem>
              </Form>
            </Card>
            <Card v-show="isAdd" dis-hover>
              <p slot="title">新增菜单</p>
              <Form :label-width="80" :model="addForm" :rules="addRules" ref="addRef">
                <FormItem label="父级菜单">
                  <Input disabled v-model="addForm.parentName" :maxlength="50"/>
                </FormItem>
                <FormItem label="菜单名称" prop="menuName">
                  <Input v-model="addForm.menuName" :maxlength="50"/>
                </FormItem>
                <FormItem label="路径" prop="url">
                  <Input v-model="addForm.url" :maxlength="50"/>
                </FormItem>
                <FormItem class="form-btn-group">
                  <Button style="margin-left: 5px;" type="success" :loading="submitLoading" @click="addItemHandler">确认
                  </Button>
                </FormItem>
              </Form>
            </Card>
          </Col>
        </Row>
      </Card>
    </Col>
  </Row>
</template>

<script>
  import { modifyRules, addRules } from './rules'

  export default {
    name: 'MenuManage',
    data () {
      return {
        platList: [],
        currentPlat: null,
        isAdd: false, // 是否是新增 默认 否
        addForm: {
          parentCode: null,
          parentName: null,
          menuName: null,
          url: null
        },
        currentMenu: {
          booleanStatus: false
        },
        modifyRules,
        addRules,
        treeData: []
      }
    },
    created () {
      this.init()
    },
    watch: {
      currentPlat: {
        handler (c) {
          c && this.getPlatMenuTree(c)
        }
      }
    },
    methods: {
      async init () {
        await this.getPlatList()
      },
      async getPlatList () {
        let { data } = await this.$http.queryCurrentUserPlatInfoList()
        let plat = data.filter(it => it.admin)
        this.platList = plat || []
        plat.length !== 0 && (this.currentPlat = plat[0].platCode)
      },
      async getPlatMenuTree (platCode) {
        let { data } = await this.$http.getPlatMenuTree({ platCode })
        let treeData = this.$utils.getPlatMenuTree(`${platCode}-平台菜单`, data)
        this.treeData = treeData
      },
      openAddHandle () {
        let checked = this.$refs['tree'].getCheckedNodes()
        let len = this.treeData.length
        if (len !== 0) { // 当前平台已经有菜单了
          if (checked.length === 0) {
            this.$Message.warning('请勾选选一个菜单做为父级')
            return
          }
          if (checked.length > 1) {
            this.$Message.warning('只能选一个菜单做为父级')
            return
          }
          let parentMenu = checked[0] || null
          // let t = parentMenu.name ? parentMenu.name : parentMenu.title
          let t = parentMenu.name
          let c = parentMenu.menuCode ? parentMenu.menuCode : ''
          this.addForm.parentName = t
          this.addForm.parentCode = c
          this.isAdd = true
          // 切换到新增后重置表单
          this.$nextTick(() => this.$refs['addRef'].resetFields())
        } else { // 新平台，没有菜单的新增
          let t = this.currentPlat
          let c = ''
          this.addForm.parentName = t
          this.addForm.parentCode = c
          this.isAdd = true
          // 切换到新增后重置表单
          this.$nextTick(() => this.$refs['addRef'].resetFields())
        }
      },
      selectChangeTree (array) {
        this.isAdd = false
        let currentMenu = array.length === 0 ? {} : array[0]
        // currentMenu.name = currentMenu.title
        currentMenu.booleanStatus = currentMenu.status === 'Y'
        // this.$refs['modifyRef'].resetFields()
        this.currentMenu = currentMenu
      },
      async postModifyMenu () {
        if (!this.currentMenu.menuCode) {
          this.$Message.warning('请选择一个菜单')
          return
        }
        let v = await this.$refs['modifyRef'].validate(v => v)
        if (v) {
          let args = {
            menuCode: this.currentMenu.menuCode,
            menuName: this.currentMenu.name,
            platCode: this.currentPlat,
            status: this.currentMenu.booleanStatus ? 'Y' : 'N',
            url: this.currentMenu.path
          }
          this.submitLoading = true
          let { succ } = await this.$http.updateMenu(args)
          this.submitLoading = false
          if (succ) {
            this.$Message.success('修改菜单成功!')
          }
          this.getPlatMenuTree(this.currentPlat)
        }
      },
      async addItemHandler () {
        let v = await this.$refs['addRef'].validate(v => v)
        if (v) {
          let args = {
            menuName: this.addForm.menuName,
            parentCode: this.addForm.parentCode,
            url: this.addForm.url,
            platCode: this.currentPlat
          }
          let { succ } = await this.$http.addMenu(args)
          if (succ) {
            this.$Message.success('新增菜单成功!')
            this.getPlatMenuTree(this.currentPlat)
            this.$refs['addRef'].resetFields()
          }
        }
      },
      async removeMenuItem () {
        if (!this.currentMenu.menuCode) {
          this.$Message.warning('请选择一个菜单')
          return
        }
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认删除该菜单?</p>',
          loading: true,
          onOk: () => {
            this.doDel()
          },
          onCancel: () => {
          }
        })
      },
      async doDel () {
        let args = {
          platCode: this.currentPlat,
          menuCode: this.currentMenu.menuCode
        }
        let { succ } = await this.$http.deleteMenu(args)
        if (succ) {
          this.$Modal.remove()
          this.$Message.success('删除成功!')
          this.getPlatMenuTree(this.currentPlat)
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~@/common/style/base.less";

  .checked-row {
    background: #29773d;
  }
</style>
